import TierDeviationSelector from './TierDeviationSelector';
export default TierDeviationSelector;

//# sourceMappingURL=index.js.map